import { render, staticRenderFns } from "./DropdownBasic.vue?vue&type=template&id=62acfa7c&scoped=true"
import script from "./DropdownBasic.vue?vue&type=script&lang=js"
export * from "./DropdownBasic.vue?vue&type=script&lang=js"
import style0 from "./DropdownBasic.vue?vue&type=style&index=0&id=62acfa7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62acfa7c",
  null
  
)

export default component.exports